<template>
	<div class="mb-5 mt-5 pl-5 pr-5" style="max-width: 550px;">
		<h3>Fraktpris</h3>
		<loading-spinner v-if="! priceList" />
		<table v-else class="table table-condensed table-striped shipping-price-table d-flex flex-wrap mt-5">
			<tbody>
				<tr v-for="method in priceList" style="text-align: left">
					<td>
						<div class="ell-wrap">
							<div class="ell">
								{{ method.name }}
							</div>
						</div>
					</td>
					<td>
						<span class="pull-right">
							<s v-if="method.regularPrice" class="mr-3 small">
								{{ method.regularPrice }} kr
							</s>
							<b>{{ method.price }} kr</b>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="px-4">
			{{ t('SHIPPING_POPUP.INFORMATION') }}
		</div>
	</div>
</template>

<style scoped>
.shipping-price-table td {
	white-space: nowrap;
}
</style>

<script>
import { t } from 'datastore/i18n';
import { formatPrice } from 'utils';

export default {
	props: ['shippingClass', 'packageSizeId', 'product', 'priceList'],
	methods: {
		t,
		formatPrice,
	},
};
</script>
